import { EntityState } from '@ngrx/entity';

export class NamedString {
    constructor(public key: string, public text: string) {}
}

export interface FeatureState extends EntityState<NamedString> {
    debugMode: boolean;
}
